import { render, staticRenderFns } from "./CourseTaskHistory.vue?vue&type=template&id=5f9d4215&scoped=true"
import script from "./CourseTaskHistory.vue?vue&type=script&lang=js"
export * from "./CourseTaskHistory.vue?vue&type=script&lang=js"
import style0 from "./CourseTaskHistory.vue?vue&type=style&index=0&id=5f9d4215&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d4215",
  null
  
)

export default component.exports